<div class="modal">
  <h1 class="title">
    <div class="title__text">Configuration</div>
    <div class="title__close_button">
      <button (click)="emitCloseModal()">x</button>
    </div>
  </h1>
  <div class="body">
    <section class="section">
      <h2 class="section__title">Default habits</h2>
      <div class="section__content">
        <app-habit
          class="habit"
          *ngFor="let habit of habits$ | async | keyvalue; trackBy: trackByFn"
          [habit]="habit.value"
          [showStrikes]="false"
          (delete)="emitDeleteDefaultHabit(habit.value)"
        ></app-habit>
      </div>
    </section>
  </div>
  <div class="footer">
    <form class="form" [formGroup]="form">
      <div class="input">
        <input class="input__box" type="text" formControlName="habit" />
      </div>
      <button class="form__button" (click)="emitAddDefaultHabit()">+</button>
    </form>
  </div>
</div>
